import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { useDeleteTestSession } from "@/hooks/useTestSessions";

type Props = {
  sessionId: string;
  open: boolean;
  onClose: () => void;
  onDeleted?: () => void;
};

export function DeleteTestSessionDialog({
  sessionId,
  open,
  onClose,
  onDeleted,
}: Props): React.JSX.Element {
  const deleteSession = useDeleteTestSession();

  function handleConfirm(): void {
    deleteSession.mutate(sessionId, {
      onSuccess: () => {
        toast.success("Prueba eliminada");
        onClose();
        onDeleted?.();
      },
      onError: (err) => toast.error(err.message ?? "Error al eliminar"),
    });
  }

  return (
    <AlertDialog open={open} onOpenChange={(v: boolean) => !v && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar esta prueba?</AlertDialogTitle>
          <AlertDialogDescription>
            Se ocultará de la lista de pruebas. Esta acción no elimina datos de
            producción.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteSession.isPending}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={deleteSession.isPending}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {deleteSession.isPending ? "Eliminando…" : "Eliminar"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
